export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.memvy';

export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/memvy/id6757810342';
